import React, { FunctionComponent } from 'react';
import { Route, Switch } from 'react-router';
import PublicationsPage from 'apps/publications/pages/publications';
import PublicationsLayout from 'apps/publications/layout';

const PublicationsPages: FunctionComponent = () => {
  return (
    <PublicationsLayout>
      <Switch>
        <Route path="/" exact component={PublicationsPage} />
      </Switch>
    </PublicationsLayout>
  );
};

export default PublicationsPages;
